(()=>{
'use strict';
const breakpoint=1200;
const levels=['Everyday Chic','Little Luxuries','Fine Treasures','Haute Joaillerie'];
const worldHrefs=['/collections/everyday-chic','/collections/little-luxuries','/collections/fine-treasures','/collections/haute-joaillerie'];
const data=window.ABMobileNavV7Data;
if(!data)return;
const backIcon='<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M19 12H5.5M12 5.5 5.5 12l6.5 6.5"/></svg>';
const closeIcon='<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m6 6 12 12M18 6 6 18"/></svg>';
const esc=s=>String(s||'').replace(/[&<>"']/g,ch=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
const norm=s=>String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
const safeUrl=s=>typeof s==='string'&&(/^(https:\/\/(cdn\.shopify\.com|www\.aureusboutique\.com)\/)/i.test(s)||/^\/(collections|pages|blogs|search)(\/|$)/i.test(s))?s:'#';
const responsiveImage=url=>{const raw=safeUrl(url);if(raw==='#')return null;try{const u=new URL(raw,location.origin);if(!/cdn\.shopify\.com|aureusboutique\.com$/i.test(u.hostname))return {src:raw};const bases=[320,480,640];const withWidth=w=>{const copy=new URL(u);copy.searchParams.set('width',String(w));return copy.href};return {src:withWidth(480),srcset:bases.map(w=>withWidth(w)+' '+w+'w').join(', ')};}catch(e){return {src:raw}}};
const image=(url,ratio='landscape')=>{const src=responsiveImage(url);return src?'<span class="abv7-image abv7-'+ratio+'"><img src="'+esc(src.src)+'" '+(src.srcset?'srcset="'+esc(src.srcset)+'" sizes="(max-width: 480px) calc((100vw - 34px)/2), 220px" ':'')+'alt="" width="480" height="'+(ratio==='portrait'?'600':'320')+'" loading="lazy" decoding="async"></span>':'<span class="abv7-image abv7-'+ratio+'"></span>'};
const $=q=>document.querySelector(q);
let drawer,trigger,rootData=[],themes=[],gems=[],designers=[],panel,scroll,history=[{type:'root'}],tab='curations',search='',letter='ALL',rootSelection='',lastFocus=null,previousOverflow='',previousInert=[],sessionKey=null;
function sourceLabel(el){return (el?.dataset?.abPanelTitle||el?.querySelector(':scope > summary .ab-mobile-nav__root-title')?.textContent||el?.querySelector(':scope > summary span')?.textContent||el?.querySelector(':scope > a .ab-mobile-nav__root-title')?.textContent||el?.querySelector(':scope > a')?.textContent||'').trim().replace(/\s+/g,' ')}
function menuItems(ul){
 return [...(ul?.children||[])].map(li=>{
 const details=li.querySelector(':scope > details');
 const anchor=li.querySelector(':scope > a');
 const direct=details?.querySelector(':scope > summary');
 let name=(details?.dataset?.abPanelTitle||anchor?.querySelector('.ab-mobile-nav__visual-title,.ab-mobile-nav__overview-copy strong')?.textContent||sourceLabel(details||li)||sourceLabel(direct)).trim();
 // Shopify's second-level submenus have a direct UL; first-level submenus
 // wrap their UL in .menu-drawer__inner-submenu. Support both native shapes.
 const submenu=details?.querySelector(':scope > .menu-drawer__submenu');
 const wrapper=submenu?.querySelector(':scope > .menu-drawer__inner-submenu')||submenu;
 const childList=wrapper?.querySelector(':scope > ul.menu-drawer__menu, :scope > ul');
 const children=childList?menuItems(childList):[];
 const allAnchor=childList?.querySelector('a[href]');
 const href=anchor?.getAttribute('href')||allAnchor?.getAttribute('href')||'';
 return {name,href,children};
 }).filter(x=>x.name);
}
function catalog(){
 const root=drawer.querySelector('.menu-drawer__navigation > ul');
 rootData=menuItems(root);
 const from=n=>rootData.find(i=>norm(i.name)===norm(n));
 themes=from('Themes')?.children||[];
 gems=from('Gemstones')?.children||[];
 const script=$('.ab-mobile-nav-config-section .ab-designer__data')||$('.ab-designer__data');
 try{designers=JSON.parse(script?.textContent||'[]')}catch(e){designers=[]}
}
function cta(label,url,outline=false){return '<a class="abv7-pill'+(outline?' abv7-pill-outline':'')+'" href="'+esc(safeUrl(url))+'">'+esc(label||'Explore All')+'</a>'}
function heading(name,href,outline=true){return '<div class="abv7-heading"><h2>'+esc(name)+'</h2>'+(href?cta('Explore All',href,outline):'')+'</div>'}
function card(name,url,href,sub='',portrait=false){return '<a class="abv7-card" href="'+esc(safeUrl(href))+'">'+image(url,portrait?'portrait':'landscape')+'<span class="abv7-cardcopy"><strong>'+esc(name)+'</strong>'+(sub?'<small>'+esc(sub)+'</small>':'')+'</span></a>'}
function choose(name,url,action,sub='',portrait=false){return '<button type="button" class="abv7-card" data-command="'+esc(action)+'">'+image(url,portrait?'portrait':'landscape')+'<span class="abv7-cardcopy"><strong>'+esc(name)+'</strong>'+(sub?'<small>'+esc(sub)+'</small>':'')+'</span></button>'}
function folderNames(state){switch(state.type){
case 'root':return [];
case 'category':return ['MENU',state.cat];
case 'curation':return ['MENU',state.cat,levels[state.ci]];
case 'style':return ['MENU',state.cat,state.name];
case 'stylecur':return ['MENU',state.cat,levels[state.ci],state.name];
case 'curationHub':return ['MENU','CURATIONS'];
case 'curationWorld':return ['MENU','CURATIONS',levels[state.ci]];
case 'themes':return ['MENU','THEMES'];
case 'theme':return ['MENU','THEMES',state.name];
case 'gems':return ['MENU','GEMSTONES'];
case 'designers':return ['MENU','DESIGNERS'];
default:return ['MENU',state.name||'EXPLORE'];}}
function folders(state){const names=folderNames(state);return names.length?'<nav class="abv7-folders" aria-label="Navigation path">'+names.map((n,i)=>'<button type="button" data-command="folder" data-level="'+i+'" class="'+(i===names.length-1?'current':'')+'" '+(i===names.length-1?'aria-current="step"':'')+'>'+esc(n)+'</button>').join('')+'</nav>':''}
function root(){
 const first=['Rings','Earrings','Necklaces','Bracelets','Designers','Curations','Themes','Gemstones'];
 return '<div class="abv7-rootlist">'+first.map(n=>'<button type="button" class="abv7-rootitem '+(rootSelection===n?'selected':'')+'" data-command="root" data-name="'+n+'">'+n+'</button>').join('')+'</div><div class="abv7-rootbottom"><div class="abv7-wave" aria-hidden="true"></div><div class="abv7-utilities"><a href="/collections/our-story">OUR STORY</a><a href="/blogs/articles">JOURNAL</a><a href="/pages/contact">CONTACT US</a></div><div class="abv7-tagline">The world of jewelry, thoughtfully curated.</div></div>'
}
function category(state){
 const cat=state.cat,d=data.categories[cat],url='/collections/all-'+cat.toLowerCase();
 // Rings does not currently have silhouette pages: link its four curation cards
 // straight to the real Shopify collections rather than opening empty submenus.
 if(!d.styles.length){
   return heading(cat,url)+'<div class="abv7-grid">'+d.curations.map(x=>card(x.name,x.img,x.href,x.sub)).join('')+'</div>';
 }
 const cards=tab==='curations'
   ?d.curations.map((x,i)=>choose(x.name,x.img,'open-curation:'+i,x.sub)).join('')
   :d.styles.map(x=>choose(x.name,x.levels[0].img,'open-style:'+x.name)).join('');
 return heading(cat,url)+'<div class="abv7-switch" role="group" aria-label="Browse '+esc(cat)+'"><button data-command="tab-curations" aria-pressed="'+(tab==='curations'?'true':'false')+'" class="'+(tab==='curations'?'active':'')+'">BY CURATION</button><button data-command="tab-styles" aria-pressed="'+(tab==='styles'?'true':'false')+'" class="'+(tab==='styles'?'active':'')+'">BY SILHOUETTE</button></div><div class="abv7-grid">'+cards+'</div>';
}
function curation(state){
 const d=data.categories[state.cat];
 return heading(levels[state.ci]+' '+state.cat,d.curations[state.ci].href)+'<div class="abv7-grid">'+d.styles.map(x=>{const part=x.levels[state.ci];return card(x.name,part.img,part.href)}).join('')+'</div>'
}
function style(state){
 const d=data.categories[state.cat],item=d.styles.find(x=>x.name===state.name);
 return heading(state.name+' '+state.cat,'')+'<div class="abv7-grid">'+item.levels.map((x,i)=>card(levels[i],x.img,x.href,d.curations[i].sub)).join('')+'</div>'
}
function curationHub(){return heading('CURATIONS','')+'<div class="abv7-grid">'+levels.map((n,i)=>choose(n,data.categories.Earrings.curations[i].img,'open-world:'+i,data.categories.Earrings.curations[i].sub)).join('')+'</div>'}
function curationWorld(state){return heading(levels[state.ci],worldHrefs[state.ci])+'<div class="abv7-grid">'+['Rings','Earrings','Necklaces','Bracelets'].map(n=>card(n,data.categories[n].curations[state.ci].img,data.categories[n].curations[state.ci].href)).join('')+'</div>'}
function themeGroupSource(name){const lookup=themes.find(t=>norm(t.name).includes(norm(name))||norm(name).includes(norm(t.name)));return lookup?.children||[]}
function themesHome(){
 const a=data.themeGroups;return heading('THEMES','/collections/all-themes')+'<div class="abv7-grid">'+a.map(x=>choose(x.name,x.img,'open-theme:'+x.name)).join('')+'</div>'
}
function themePage(state){
 const children=themeGroupSource(state.name);
 return heading(state.name,'')+'<div class="abv7-grid">'+children.map(x=>card(x.name,data.themeMedia[x.name]||data.themeMedia[x.name.replace(/s$/,'')]||'',x.href)).join('')+'</div>'
}
function gemstones(){
 const gemAliases={Diamonds:'Diamond',Pearls:'Pearl',Emeralds:'Emerald'};
 const flat=gems.flatMap(x=>x.children?.length?x.children:[x]),unique=new Map();for(const g of flat){if(!unique.has(g.name))unique.set(g.name,g)}
 return heading('GEMSTONES','')+'<div class="abv7-grid">'+[...unique.values()].map(x=>card(x.name,data.gemstoneMedia[gemAliases[x.name]||x.name]||'',x.href)).join('')+'</div>';
}
function filtered(){
 const names=designers.filter(d=>norm(d.name).includes(norm(search)));
 const letters=[...new Set(designers.map(d=>norm(d.name)[0]?.toUpperCase()).filter(Boolean))].sort();
 const results=names.filter(x=>letter==='ALL'||norm(x.name).startsWith(norm(letter))).sort((a,b)=>a.name.localeCompare(b.name));
 return '<div class="abv7-azlabel">EXPLORE A–Z</div><div class="abv7-az" role="group" aria-label="Filter designers by letter" tabindex="0">'+['ALL',...letters].map(n=>'<button type="button" data-command="letter" data-name="'+esc(n)+'" aria-pressed="'+(n===letter?'true':'false')+'" class="'+(n===letter?'current':'')+'">'+(n==='ALL'?'All':esc(n))+'</button>').join('')+'</div><p class="abv7-result-count" role="status" aria-live="polite" aria-atomic="true">'+results.length+' '+(results.length===1?'designer':'designers')+'</p><div class="abv7-names">'+results.map(x=>'<a href="'+esc(safeUrl(x.url))+'">'+esc(x.name)+'</a>').join('')+'</div>'+(results.length?'':'<p class="abv7-empty">NO MATCHING DESIGNERS.</p>');
}
function selectedInFocusNames(){
 const source=$('#ABInFocusSelectedNames');
 let raw='';
 try{raw=JSON.parse(source?.textContent||'""')}catch(e){}
 // Matches the shared desktop fallback if a pre-upgrade header is cached.
 const fallback=['AWE INSPIRED','CHOW SANG SANG','ANGARA','SATYA','OLA SHEKHTMAN','SWAROVSKI','AURATE','MELINDA MARIA','LOREN HOPE','TOUS'];
 const parsed=String(raw||'').split(/[,\n]+/).map(name=>name.trim()).filter(Boolean).slice(0,10);
 return parsed.length?parsed:fallback;
}
function designersPage(){
 const aliases={'AURATE':'AURATE NEW YORK'};
 const seen=new Set();
 const features=selectedInFocusNames().map(name=>{
   const lookup=norm(aliases[name.toUpperCase()]||name);
   if(seen.has(lookup))return '';
   const found=designers.find(x=>norm(x.name)===lookup);
   if(!found||!found.img||!found.url)return '';
   seen.add(lookup);
   const label=lookup===norm('AURATE NEW YORK')?'AURATE':found.name;
   return card(label,found.img,found.url,'',true);
 }).join('');
 return heading('DESIGNERS','/collections/designers')+'<div class="abv7-search"><svg class="abv7-search-icon" viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.8" cy="10.8" r="6.8"/><path d="m16 16 5 5"/></svg><input type="search" placeholder="Search designers by name..." aria-label="Search designers by name" aria-controls="abv7-results" value="'+esc(search)+'" autocomplete="off"><button type="button" class="abv7-search-clear" aria-label="Clear designer search" '+(search?'':'hidden')+'><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5 19 19M19 5 5 19"/></svg></button></div><div id="abv7-featured" '+(search.trim()?'hidden':'')+'><div class="abv7-azlabel">IN FOCUS</div><div class="abv7-portraits" tabindex="0" aria-label="In Focus designers, swipe horizontally">'+features+'</div></div><div id="abv7-results">'+filtered()+'</div>'
}
function page(state){switch(state.type){case 'root':return root();case 'category':return category(state);case 'curation':return curation(state);case 'style':return style(state);case 'curationHub':return curationHub();case 'curationWorld':return curationWorld(state);case 'themes':return themesHome();case 'theme':return themePage(state);case 'gems':return gemstones();case 'designers':return designersPage();default:return root()}}
function render(){
 const state=history[history.length-1];
 scroll.innerHTML=folders(state)+'<div class="abv7-page '+(state.type==='root'?'abv7-root':'')+'">'+page(state)+'</div>';
 scroll.scrollTop=0;
 const foldersEl=scroll.querySelector('.abv7-folders');
 if(foldersEl)foldersEl.scrollLeft=foldersEl.scrollWidth;
 const backButton=panel.querySelector('.abv7-back');
 backButton.setAttribute('aria-label',history.length>1?'Back':'Close navigation');
 backButton.innerHTML=history.length>1?backIcon:closeIcon;
 const heading=scroll.querySelector('.abv7-heading h2');
 if(heading){heading.setAttribute('tabindex','-1');heading.focus({preventScroll:true})}
}
function currentSnapshot(){
 return {path:history.map(x=>({type:x.type,cat:x.cat,ci:x.ci,name:x.name,scroll:x.scroll||0})),tab,letter,search,rootSelection};
}
function pushHistory(){
 window.history.pushState({abv7:sessionKey,snapshot:currentSnapshot()},'');
}
function isolateBackground(){
 previousInert=[];
 [...document.body.children].forEach(el=>{
   if(el===panel)return;
   previousInert.push([el,el.inert]);
   el.inert=true;
 });
}
function restoreBackground(){
 previousInert.forEach(([el,was])=>el.inert=was);
 previousInert=[];
}
function showOverlay(){
 if(!panel.hidden)return;
 previousOverflow=document.body.style.overflow;
 panel.hidden=false;
 isolateBackground();
 document.body.classList.add('abv7-open');
 document.body.style.overflow='hidden';
 trigger?.setAttribute('aria-expanded','true');
}
function hideOverlay(){
 if(panel.hidden)return;
 panel.hidden=true;
 restoreBackground();
 document.body.classList.remove('abv7-open');
 document.body.style.overflow=previousOverflow;
 trigger?.setAttribute('aria-expanded','false');
 lastFocus?.focus({preventScroll:true});
}
function restoreSnapshot(snapshot){
 if(!snapshot||!Array.isArray(snapshot.path)||!snapshot.path.length)return false;
 history=snapshot.path.map(x=>({type:x.type,cat:x.cat,ci:x.ci,name:x.name,scroll:x.scroll||0}));
 tab=snapshot.tab||'curations';
 letter=snapshot.letter||'ALL';
 search=snapshot.search||'';
 rootSelection=snapshot.rootSelection||'';
 render();
 scroll.scrollTop=history[history.length-1].scroll||0;
 return true;
}
function push(next){
 history[history.length-1].scroll=scroll.scrollTop;
 history.push(next);
 pushHistory();
 render();
}
function back(){
 if(panel.hidden)return;
 if(window.history.state?.abv7===sessionKey){window.history.back();return}
 hideOverlay();
}
function close(){
 if(panel.hidden)return;
 hideOverlay();
 // Unwind menu-only entries so a subsequent Android Back does not revisit
 // the dismissed overlay. Snapshots remain in browser history for valid Forward.
 if(window.history.state?.abv7===sessionKey)window.history.go(-history.length);
}
function open(){
 lastFocus=document.activeElement;
 catalog();
 history=[{type:'root'}];
 tab='curations';search='';letter='ALL';rootSelection='';
 sessionKey='abv7-'+Date.now();
 showOverlay();
 pushHistory();
 render();
 panel.querySelector('.abv7-back')?.focus({preventScroll:true});
}
function handleHistoryChange(){
 const state=window.history.state;
 if(state?.abv7===sessionKey&&window.innerWidth<breakpoint){
   if(panel.hidden){
     lastFocus=trigger;
     catalog();
     showOverlay();
   }
   restoreSnapshot(state.snapshot);
 }else{
   hideOverlay();
 }
}
function handleViewportChange(){
 if(window.innerWidth>=breakpoint&&!panel.hidden)close();
}
function onClick(event){const b=event.target.closest('[data-command]');if(!b||!panel.contains(b))return;const action=b.dataset.command;event.preventDefault();if(action==='root'){const n=b.dataset.name;rootSelection=n;const types={Designers:'designers',Curations:'curationHub',Themes:'themes',Gemstones:'gems'};if(data.categories[n])push({type:'category',cat:n});else if(types[n])push({type:types[n]})}
 else if(action==='folder'){const idx=Number(b.dataset.level);if(idx<history.length-1){const n=history.length-1-idx;window.history.go(-n)}}
 else if(action==='tab-curations'||action==='tab-styles'){tab=action==='tab-curations'?'curations':'styles';render()}
 else if(action.startsWith('open-curation:'))push({type:'curation',cat:history.at(-1).cat,ci:Number(action.split(':')[1])});
 else if(action.startsWith('open-style:'))push({type:'style',cat:history.at(-1).cat,name:action.split(':')[1]});
 else if(action.startsWith('open-world:'))push({type:'curationWorld',ci:Number(action.split(':')[1])});
 else if(action.startsWith('open-theme:'))push({type:'theme',name:action.split(':')[1]});
 else if(action==='letter'){
   letter=b.dataset.name;
   search='';
   const input=panel.querySelector('.abv7-search input');
   if(input)input.value='';
   const featured=panel.querySelector('#abv7-featured');if(featured)featured.hidden=false;
   const clear=panel.querySelector('.abv7-search-clear');if(clear)clear.hidden=true;
   const rail=panel.querySelector('.abv7-az');
   const railLeft=rail?.scrollLeft||0;
   const node=panel.querySelector('#abv7-results');
   if(node){node.innerHTML=filtered();const newRail=node.querySelector('.abv7-az');if(newRail)newRail.scrollLeft=railLeft;node.querySelector('.abv7-az button.current')?.focus({preventScroll:true})}
 }}
function init(){
 drawer=$('#menu-drawer');trigger=$('header-drawer > details > summary');if(!drawer||!trigger||!$('.ab-mobile-nav-config-section'))return;
 if($('#abv7-overlay'))return;
 const enabledConfig=$('.ab-mobile-nav-config-section [data-ab-mobile-nav-config]');
 try{if(JSON.parse(enabledConfig?.textContent||'{}').enabled===false)return}catch(e){}
 panel=document.createElement('div');panel.id='abv7-overlay';panel.hidden=true;panel.setAttribute('role','dialog');panel.setAttribute('aria-modal','true');panel.setAttribute('aria-label','Aureus Boutique navigation');
 panel.innerHTML='<div class="abv7-top"><button type="button" class="abv7-back" aria-label="Close navigation">' + closeIcon + '</button><a class="abv7-logo" href="/" aria-label="Aureus Boutique home"><img src="https://www.aureusboutique.com/cdn/shop/files/aureus-boutique-logo_46339049-3d09-4742-a39f-6fc9a394dd8c.svg?v=1718749342" alt="" width="164" height="50" decoding="async"></a><a class="abv7-topsearch" href="/search" aria-label="Search all jewelry"><svg viewBox="0 0 24 24"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m16 16 5 5"/></svg></a></div><div class="abv7-scroll"></div>';
 document.body.appendChild(panel);scroll=panel.querySelector('.abv7-scroll');panel.addEventListener('click',onClick);
 window.addEventListener('popstate',handleHistoryChange);
 window.addEventListener('resize',handleViewportChange,{passive:true});
 window.addEventListener('pageshow',()=>{if(!panel.hidden)handleViewportChange()});
 panel.querySelector('.abv7-back').addEventListener('click',back);
 function updateDesignerSearch(value){
 search=value;letter='ALL';
 const results=panel.querySelector('#abv7-results');
 if(results){
   const oldRail=results.querySelector('.abv7-az');const railLeft=oldRail?.scrollLeft||0;
   results.innerHTML=filtered();
   const newRail=results.querySelector('.abv7-az');if(newRail)newRail.scrollLeft=railLeft;
 }
 const featured=panel.querySelector('#abv7-featured');
 if(featured)featured.hidden=Boolean(search.trim());
 const clearButton=panel.querySelector('.abv7-search-clear');
 if(clearButton)clearButton.hidden=!search;
}
 panel.addEventListener('input',e=>{if(e.target.matches('.abv7-search input'))updateDesignerSearch(e.target.value)});
 panel.addEventListener('click',e=>{
   const clearButton=e.target.closest('.abv7-search-clear');
   if(!clearButton)return;
   const input=panel.querySelector('.abv7-search input');
   if(input){input.value='';updateDesignerSearch('');input.focus({preventScroll:true})}
 });
 document.addEventListener('keydown',e=>{if(panel.hidden)return;if(e.key==='Escape'){e.preventDefault();back();return}if(e.key==='Tab'){const all=[...panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])')].filter(x=>x.getClientRects().length);if(!all.length)return;const first=all[0],last=all.at(-1);if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}}});
 trigger.addEventListener('click',e=>{if(window.innerWidth>=breakpoint)return;e.preventDefault();e.stopImmediatePropagation();e.stopPropagation();if(panel.hidden)open();else close()},true);

}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();